import {
    Box,
    Button,
    CardActions,
    CardContent,
    Container,
    Drawer,
    FormControl,
    FormHelperText,
    Grid,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import { FileUploaderSingle } from '../../components/upload';
import DropzoneWrapper from '../../styles/react-dropzone';

const DialogGiftCategory = (props) => {
    const { show, setShow, setReload } = props
    const [files, setFiles] = useState([]);
    const defaultValues = {
        title: '',
    }
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();

    useEffect(() => {
        reset(defaultValues);
        !show && setFiles([]);
    }, [show]);

    const onSubmit = async (data, e) => {
        e.preventDefault();

        if(files.length == 0) {
            toast.error('No file selection', {
                position: "top-center"
            })
            return false;
        }

        const [file] = files;
        const formData = new FormData()

        formData.append('title', data.title);
        formData.append('file', file);

        try {
            await apiService.postFormData('/giftshopcategory', formData)
            toast.success('등록 되었습니다.')
            setReload(reload => reload + 1)
        } catch (error) {
            toast.error('등록이 실패했습니다.')
            console.error(error)
        } finally {
            setShow(false)
        }
    }

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setShow(open);
    };

    return (
        <Drawer anchor='right' open={show} onClose={toggleDrawer(false)}>
            <Container sx={{width: '800px', pt: 8, px: '2rem !important'}}>
                <form onSubmit={handleSubmit(onSubmit)} id="giftform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                상품권 카테고리 등록
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>                    
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='title'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                fullWidth
                                                label='타이틀'
                                                id='title'
                                                onChange={onChange}
                                                placeholder='타이틀을 입력해주세요'
                                                error={Boolean(errors.title)}
                                                aria-describedby='validation-async-title'
                                            />
                                        )}
                                    />
                                    {errors.title && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <DropzoneWrapper>
                                    <FileUploaderSingle files={files} setFiles={setFiles} />
                                </DropzoneWrapper>
                            </Grid>

                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="giftform" variant='contained'> 등록 </Button>
                    <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
                        취소
                    </Button>
                </CardActions>
            </Container>
        </Drawer>        
    )
}

export default DialogGiftCategory